import update from 'immutability-helper';

/**
 * Returns array with both original values and new values.
 * If the new value is array, all its elements are added. Otherwise the whole object is added as element.
 *
 * @param array the original array
 * @param value the value to put.
 * @returns new array with all original values and new value(s) OR the original one if there is nothing to put.
 */
export function putAll(array, value) {
    if (!value || value.length === 0) {
        return array;
    }
    if(value instanceof Array) {
        array = update(array, {$push: value});
    } else {
        array = update(array, {$push: [value]});
    }
    return array;
}

/**
 * Returns array with unique values from both original and new collections.
 * If the new value is array, all its elements are added. Otherwise the whole object is added as element.
 *
 * @param array the original array
 * @param value the value to put.
 * @returns new array with all original values and new value(s) OR the original one if there is nothing to put.
 */
export function putAllUnique(array, value) {
    return [...new Set(putAll(array, value))];
}

/**
 * Converts 2-dimensional array to 1-dimensional one.
 * E.g. [[1,2],[3,4],[5,1]] -> [1,2,3,4,5,1]
 */
export function flatMap(arrayOfArrays) {
    return [].concat.apply([], arrayOfArrays);
}


// WEBPACK FOOTER //
// ./src/utils/Array.js